import getDeviceIdCookie from '../DeviceIdCookie';
import getBundleIdCookie from '../BundleIdCookie';
import { AxiosResponse } from 'axios';
import {
  CardWithInstitution,
  Farecard,
  FarecardAutoload,
  FarecardCappingPot,
  FarecardHistoryResult,
  FarecardPass,
  Farecategory,
  FareProduct, Institution,
  PaymentMethod,
  SecurityQuestion,
} from './types/apitypes';
import handleRequests from './apiHandler';

const apiAuthHeaders = (auth: any) => ({
  Authorization: `Bearer ${auth.user?.access_token}`,
  bundleID: getBundleIdCookie(),
  deviceID: getDeviceIdCookie().device_id,
  appId: 'metro',
});

const apiAuthHeadersJson = (auth: any) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${auth.user?.access_token}`,
  bundleID: getBundleIdCookie(),
  deviceID: getDeviceIdCookie().device_id,
  appId: 'metro',
});

const apiHeadersJson = () => ({
  'Content-Type': 'application/json',
  bundleID: getBundleIdCookie(),
  deviceID: getDeviceIdCookie().device_id,
  appId: 'metro',
});

const apiAuthHeadersMultipart = (auth: any) => ({
  Authorization: `Bearer ${auth.user?.access_token}`,
  bundleID: getBundleIdCookie(),
  deviceID: getDeviceIdCookie().device_id,
  appId: 'metro',
});

const apiHeaders = () => ({
  bundleID: getBundleIdCookie(),
  deviceID: getDeviceIdCookie().device_id,
  appId: 'metro',
});

const isMockCardPassesEnabled =
  process.env.REACT_APP_MOCK_CARD_PASSES === 'true';

const mockCardPasses: FarecardPass[] = [
  {
    id: 1001,
    autoloadEnabled: false,
    isActive: true,
    name: 'Mock debug: 30 Day Local Pass',
    description: 'Mock debug fare product',
    typeId: 1,
    activateUntil: '2026-08-01T23:59:59Z',
    validFrom: '2026-07-15T00:00:00Z',
    validTo: '2026-08-14T23:59:59Z',
    validityDescription: 'Valid for 30 days',
    price: 50,
    hasAutoloads: false,
  },
  {
    id: 1002,
    autoloadEnabled: false,
    isActive: false,
    name: 'Mock debug: Day Pass',
    description: 'Mock debug fare product',
    typeId: 2,
    activateUntil: '2026-08-15T23:59:59Z',
    validFrom: '2026-08-16T00:00:00Z',
    validTo: '2026-08-16T23:59:59Z',
    validityDescription: 'Valid for one day',
    price: 3,
    hasAutoloads: false,
  },
];

const mockFareProducts: FareProduct[] = [
  {
    name: 'Mock debug: 7 Day Local Pass',
    canBePlacedInCart: true,
    typeId: 101,
    offerReference: 'mock-debug-7-day-local-pass',
    description: 'Mock debug fare product',
    price: 15,
    validityDescription: 'Valid for seven days',
    offerConstraints: { minQuantity: 1, maxQuantity: 1 },
  },
  {
    name: 'Mock debug: Day Pass',
    canBePlacedInCart: true,
    typeId: 102,
    offerReference: 'mock-debug-day-pass',
    description: 'Mock debug fare product',
    price: 3,
    validityDescription: 'Valid for one day',
    offerConstraints: { minQuantity: 1, maxQuantity: 2 },
  },
];

export const apiRegisterUser = (user: any) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'users',
    data: user,
    headers: apiHeadersJson(),
  });
};

export const apiGetFareCards = (auth: any) => {
  return handleRequests<Farecard[]>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'v2/users/fare-medias',
    headers: apiAuthHeaders(auth),
  });
};

export const apiGetInstitutionsForCard = (auth: any, cardId: Farecard["cardId"]) => {
  return handleRequests<Institution[]>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + `v2/users/fare-medias/${cardId}/institutions`,
    headers: apiAuthHeaders(auth),
  });
};

export const apiUnlinkCardToInstitution = (auth: any, institutionId: Institution["id"], cardId: Farecard["cardId"]) => {
  return handleRequests<CardWithInstitution>({
    method: 'delete',
    url: process.env.REACT_APP_API_BASE + `users/fare-medias/${cardId}/institutions/${institutionId}`,
    headers: apiAuthHeaders(auth)
  });
};


export const apiGetInstitutions = (auth: any) => {
  return handleRequests<Institution[]>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'users/institutions',
    headers: apiAuthHeaders(auth),
  });
};

export const apiLinkCardToInstitution = (auth: any, institutionId: Institution["id"], cardId: Farecard["cardId"], registrationCode: string) => {
  return handleRequests<CardWithInstitution>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + `users/fare-medias/${cardId}/institutions/${institutionId}`,
    headers: apiAuthHeaders(auth),
    params: {registrationCode}
  });
};



export const apiUpdateFareCardNickname = (
  cardId: string,
  nickname: string,
  auth: any,
) => {
  return handleRequests<Farecard>({
    method: 'patch',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/' + cardId + '/nickname',
    data: { nickname },
    headers: apiAuthHeaders(auth),
  });
};

export const apiGetCappingPots = (cardId: string, auth: any) => {
  return handleRequests<FarecardCappingPot[]>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/' + cardId + '/capping-pots',
    headers: apiAuthHeaders(auth),
  });
};

export const apiGetPaymentMethods = (auth: any) => {
  return handleRequests<PaymentMethod[]>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'users/payment-methods',
    headers: apiAuthHeaders(auth),
  });
};

export const apiGetFareCategories = () => {
  return handleRequests<Farecategory[]>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'fare-medias/fare-categories',
    headers: apiHeaders(),
  });
};

export const apiPurchase = (order: any, auth: any) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/purchase-orders',
    data: order,
    headers: apiAuthHeaders(auth),
  });
};

export const apiAddVirtualFarecard = (card: any, auth: any) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'v2/users/fare-medias/virtual-card',
    data: card,
    headers: apiAuthHeaders(auth),
  });
};

export const apiAddPhysicalFarecard = (card: any, auth: any) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/links',
    data: card,
    headers: apiAuthHeaders(auth),
  });
};

export const apiConvertFarecard = (cardId: string, auth: any) => {
  return handleRequests<any>({
    method: 'put',
    url: process.env.REACT_APP_API_BASE + 'v2/users/fare-medias/' + cardId + '/convert',
    data: {},
    headers: apiAuthHeaders(auth),
  });
};

export const apiLockFarecard = (cardId: string, auth: any) => {
  return handleRequests<any>({
    method: 'patch',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/' + cardId + '/lock',
    data: {},
    headers: apiAuthHeaders(auth),
  });
};

export const apiCardTransactions = (cardId: string, auth: any) => {
  const today = new Date();
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(today.getDate() - 30);

  return handleRequests<FarecardHistoryResult>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/' + cardId + '/transactions',
    params: {
      minDate: thirtyDaysAgo.toISOString(),
    },
    headers: apiAuthHeaders(auth),
  });
};

export const apiCardAutoloads = (cardId: string, auth: any) => {
  return handleRequests<FarecardAutoload[]>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/' + cardId + '/autoloads',
    headers: apiAuthHeaders(auth),
  });
};

export const apiCardAutoload = (cardId: string, data: any, auth: any) => {
  return handleRequests<FarecardAutoload[]>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/' + cardId + '/autoloads',
    data,
    headers: apiAuthHeaders(auth),
  });
};

export const apiCardAutoloadUpdate = (
  cardId: string,
  alId: number,
  data: any,
  auth: any,
) => {
  return handleRequests<FarecardAutoload[]>({
    method: 'put',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/' + cardId + '/autoloads/' + alId,
    data,
    headers: apiAuthHeaders(auth),
  });
};

export const apiCardAutoloadRemove = (
  cardId: string,
  alId: number,
  auth: any,
) => {
  return handleRequests<FarecardAutoload[]>({
    method: 'delete',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/' + cardId + '/autoloads/' + alId,
    headers: apiAuthHeaders(auth),
  });
};

export const apiCardPasses = (
  cardId: string,
  auth: any,
): Promise<AxiosResponse<FarecardPass[]>> => {
  if (isMockCardPassesEnabled) {
    return Promise.resolve({ data: mockCardPasses } as AxiosResponse<FarecardPass[]>);
  }

  return handleRequests<FarecardPass[]>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/' + cardId + '/fare-products',
    headers: apiAuthHeaders(auth),
  });
};

export const apiFareProducts = (
  cardId: string,
): Promise<AxiosResponse<FareProduct[]>> => {
  if (isMockCardPassesEnabled) {
    return Promise.resolve({ data: mockFareProducts } as AxiosResponse<FareProduct[]>);
  }

  return handleRequests<FareProduct[]>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'fare-products',
    params: {
      cardId: cardId,
    },
    headers: apiHeaders(),
  });
};

export const apiUnlockPhysicalFarecard = (cardId: string, auth: any) => {
  return handleRequests<any>({
    method: 'delete',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/' + cardId + '/lock',
    headers: apiAuthHeaders(auth),
  });
};

export const apiRemovePhysicalFarecard = (cardId: string, auth: any) => {
  return handleRequests<any>({
    method: 'delete',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/' + cardId + '/links',
    headers: apiAuthHeaders(auth),
  });
};

export const apiAddPaymentMethod = (card: any, auth: any) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'users/payment-methods',
    data: card,
    headers: apiAuthHeaders(auth),
  });
};

export const apiSavePaymentMethod = (id: number, card: any, auth: any) => {
  return handleRequests<any>({
    method: 'put',
    url: process.env.REACT_APP_API_BASE + 'users/payment-methods/' + id,
    data: card,
    headers: apiAuthHeaders(auth),
  });
};

export const apiDeletePaymentMethod = (id: number, auth: any) => {
  return handleRequests<any>({
    method: 'delete',
    url: process.env.REACT_APP_API_BASE + 'users/payment-methods/' + id,
    headers: apiAuthHeaders(auth),
  });
};

export const apiDeleteAccount = (auth: any) => {
  return handleRequests<any>({
    method: 'delete',
    url: process.env.REACT_APP_API_BASE + 'users',
    headers: apiAuthHeaders(auth),
  });
};

export const apiSavePassword = (pws: any, auth: any) => {
  return handleRequests<any>({
    method: 'put',
    url: process.env.REACT_APP_API_BASE + 'users/passwords',
    data: pws,
    headers: apiAuthHeadersJson(auth),
  });
};

export const apiSaveUser = (user: any, auth: any) => {
  return handleRequests<any>({
    method: 'put',
    url: process.env.REACT_APP_API_BASE + 'users',
    data: user,
    headers: apiAuthHeadersJson(auth),
  });
};

export const apiFeedback = (feedback: any, auth: any) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'feedback',
    data: feedback,
    headers: apiAuthHeadersMultipart(auth),
  });
};

export const apiHelpRequest = (helpRequest: FormData, auth: any) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'help-request',
    data: helpRequest,
    headers: apiAuthHeadersMultipart(auth),
  });
};

export const apiResendVerification = (email: string) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'users/activation',
    data: { email: email },
    headers: apiHeadersJson(),
  });
};

export const apiGetUser = (auth: any) => {
  return handleRequests<any>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'users',
    headers: apiAuthHeaders(auth),
  });
};

export const apiGetSecurityQuestion = (auth: any) => {
  return handleRequests<any>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'users/security-questions',
    headers: apiAuthHeaders(auth),
  });
};

export const apiSaveSecurityQuestion = (questions: any, auth: any) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'users/security-questions',
    data: questions,
    headers: apiAuthHeaders(auth),
  });
};

export const apiSecurityQuestions = () => {
  return handleRequests<SecurityQuestion[]>({
    method: 'get',
    url: process.env.REACT_APP_API_BASE + 'security-questions',
    headers: apiHeaders(),
  });
};

export const apiResetPassword = (email: string) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'users/passwords/reset',
    data: { email },
    headers: apiHeadersJson(),
  });
};

export const apiGooglePay = (
  data: {
    isStoredValuePayment: boolean;
    partialPayment: [];
    paymentToken: string;
    topUps?: {
      amount: number;
      cardId: string;
    }[];
    products?: {
      offerRef?: string;
      quantity: number;
    }[];
    paymentMethodData: {
      info: {
        billingAdress: Record<string, string>;
        cardDetails: string;
        cardNetwork: string;
      };
      tokenizationData: { token: string; type: string };
    };
  },
  auth: any,
) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/purchase-orders/google-pay',
    data: {
      ...data,
      paymentMethodData: undefined,
      googlePaymentData: JSON.stringify({
        paymentMethodData: data.paymentMethodData,
      }),
    },
    headers: apiAuthHeaders(auth),
  });
};

export const apiApplePay = (
  data: {
    topUps?: {
      amount: number,
      cardId: string,
    }[];
    products?: {
      offerRef?: string,
      quantity: number,
    }[];
    encryptedPaymentData: "",
    paymentToken: string,
    cardNetwork: string,
  },
  auth: any,
) => {
  return handleRequests<any>({
    method: 'post',
    url: process.env.REACT_APP_API_BASE + 'users/fare-medias/purchase-orders/apple-pay',
    data,
    headers: apiAuthHeaders(auth),
  });
};
